import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { TranslocoCurrencyPipe } from '@jsverse/transloco-locale';
import { FiltreAccueilPeriode } from '../../../FiltreAccueilPeriode';
import { LigneSuiviRegularisationDto, RetournerStatistiquesSuiviRegularisationsAchatResultat } from '../../../RetournerStatistiquesSuiviRegularisationsAchatResultat';
import { EFactAchatService } from '../../../val-efact-achat.service';
import { CarteDashboardComponent } from '../../carte-dashboard/carte-dashboard.component';

// Carte de suivi des régularisations (achat)
@Component({
	selector: 'val-carte-suivi-regularisations-achat',
	imports: [
		TranslocoModule,
		TranslocoCurrencyPipe,
		CarteDashboardComponent
	],
	templateUrl: './carte-suivi-regularisations.component.html',
	styleUrl: './carte-suivi-regularisations.component.scss'
})
export class CarteSuiviRegularisationsAchatComponent implements OnInit, OnChanges {

	constructor(private eFactAchatService: EFactAchatService, private router: Router) {
		this.filtrePeriode = FiltreAccueilPeriode.TrenteJours;
		this.chargementEnCours = false;
		this.estEnErreur = false;
		this.donnees = null;
		this.lignes = [];
	}

	// Période sélectionnée dans le filtre temporel
	@Input()
	public filtrePeriode: FiltreAccueilPeriode;

	// Indique si le chargement des données est en cours
	public chargementEnCours: boolean;

	// Indique si le dernier chargement s'est soldé par une erreur
	public estEnErreur: boolean;

	// Données de la carte
	public donnees: RetournerStatistiquesSuiviRegularisationsAchatResultat | null;

	// Lignes du panel, dans l'ordre d'affichage, avec leur clé de libellé i18n (recalculées à chaque chargement)
	public lignes: { cleLibelle: string; donnee: LigneSuiviRegularisationDto }[];

	public async ngOnInit(): Promise<void> {
		await this.chargerDonnees();
	}

	public async ngOnChanges(changes: SimpleChanges): Promise<void> {
		if (changes['filtrePeriode'] && !changes['filtrePeriode'].firstChange)
			await this.chargerDonnees();
	}

	// Construit les lignes du panel, dans l'ordre d'affichage, avec leur clé de libellé i18n
	private ConstruireLignes(donnees: RetournerStatistiquesSuiviRegularisationsAchatResultat): { cleLibelle: string; donnee: LigneSuiviRegularisationDto }[] {
		return [
			{ cleLibelle: 'dashboard.carte-suivi-regularisations-achat.a-approuver', donnee: donnees.aApprouver },
			{ cleLibelle: 'dashboard.carte-suivi-regularisations-achat.retours-fournisseurs-a-valider', donnee: donnees.retoursFournisseursAValider },
			{ cleLibelle: 'dashboard.carte-suivi-regularisations-achat.a-payer', donnee: donnees.facturesAPayer }
		];
	}

	// Calcule la couleur de fond au survol (couleur de la ligne à 20% d'opacité)
	public CalculerCouleurFond(couleurCode: string | null | undefined): string {
		let couleurHex: string;
		let r: number;
		let g: number;
		let b: number;

		if (!couleurCode)
			return 'transparent';

		couleurHex = couleurCode.replace('#', '');
		r = parseInt(couleurHex.slice(0, 2), 16);
		g = parseInt(couleurHex.slice(2, 4), 16);
		b = parseInt(couleurHex.slice(4, 6), 16);

		return `rgba(${r}, ${g}, ${b}, 0.2)`;
	}

	// Navigue vers la grille des factures d'achat
	public NaviguerVersFacturesAchat(): void {
		this.router.navigate(["/main", { outlets: { page: ['recherche-facture-achat'] } }], { skipLocationChange: true });
	}

	private async chargerDonnees(): Promise<void> {
		this.chargementEnCours = true;
		this.estEnErreur = false;
		this.donnees = null;
		this.lignes = [];

		try {
			const resultat = await this.eFactAchatService.RetournerStatistiquesSuiviRegularisations(this.filtrePeriode);
			if (resultat.status === 'success' && resultat.resultat) {
				this.donnees = resultat.resultat;
				this.lignes = this.ConstruireLignes(this.donnees);
			} else {
				this.estEnErreur = true;
			}
		} catch {
			this.estEnErreur = true;
		} finally {
			this.chargementEnCours = false;
		}
	}
}
